import * as TYPES from 'constants/ActionTypes';
import { custom } from 'utils/Api';
import { get, pickBy, map, orderBy, replace, keyBy } from 'lodash';

export const requestWebValues = () => ({
  type: TYPES.REQUEST_WEB_VALUES,
});

export const requestWebValuesSuccess = ({ valuesKeyed, links }) => ({
  type: TYPES.REQUEST_WEB_VALUES_SUCCESS,
  links,
  valuesByKey: valuesKeyed,
});

export const requestWebValuesFailure = error => ({
  type: TYPES.REQUEST_WEB_VALUES_FAILURE,
  error,
});

export const fetchWebValues = cb =>
  async (dispatch, getState) => {
    try {
      const {
        loginReducer: { user: { token } },
        WebValuesReducer: {
          timeStamp,
          valuesByKey,
        },
      } = getState();
      // If we fetched the values recently we do not fetch them again
      if (timeStamp && (Date.now() > (timeStamp + 360000))) {
        cb && cb(valuesByKey);
      } else {
        dispatch(requestWebValues());
        const webValuesRequest = ({
          headers: { Authorization: `Bearer ${token}` },
          url: "/kjarni/api/v2/WebValues/MyWebValues(code='Employee.Web')",
          method: 'GET',
        });
        const webValues = get(await custom(webValuesRequest), 'data.value', []);
        const valuesKeyed = keyBy(webValues, x => replace(x.Code, 'Employee.Web.', ''));
        const links = orderBy(map(pickBy(valuesKeyed, x => x.Code.startsWith('Employee.Web.Link')), x => x), 'Description');
        dispatch(requestWebValuesSuccess({ valuesKeyed, links }));
        cb && cb(valuesKeyed);
      }
    } catch (error) {
      dispatch(requestWebValuesFailure(error));
      window.location.replace('/account?logout=true');
    }
  };



// WEBPACK FOOTER //
// ./src/actions/WebValues.js